export const isDev = process.env.NODE_ENV === 'development';
export const isProd = process.env.NODE_ENV === 'production';
export const rootPath = '/';

export const CONFIGS = {
  sale0001: {
    expireAt: '2020-12-31',
  }
}
